import React, { useEffect, useState } from 'react';
import { getOnboardingUrl } from "../../utils/portalUrl";
import { trackViewBusinessCategory } from "../../utils/track";
import { useTranslation } from 'react-i18next';
import { FaCheckCircle, FaWhatsapp, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import {
  FaCut, FaSpa, FaTooth, FaHospital, FaVideo, FaQuestionCircle, FaRegGem,
  FaDumbbell, FaSun, FaPenNib, FaPaw, FaLeaf, FaHands, FaUserTie,
  FaBolt, FaSyringe, FaGraduationCap, FaUmbrellaBeach, FaWalking, FaAppleAlt,
} from 'react-icons/fa';
import Navbar from '../../Components/Navbar/Navbar';
import Footer from '../../Components/Footer/Footer';
import SEO from '../../Components/SEO/SEO';
import { CATEGORY_META as SEO_CATEGORY_META } from '../../seo/pageMeta';
import { RICH_VERTICALS } from './richVerticals';
import DeepDive from '../../Components/DeepDive';
import RelatedLinks from '../../Components/RelatedLinks';
import styles from './BusinessCategoryPage.module.css';

// Hero images
import SalonGradient from '../../assets/Industry_Salon_Hero_Gradient-9aee5741fb52f24c8319f20cac18d941.svg';
import SalonPhoto from '../../assets/Industry_Salon_Software_Fresha.e60d3dd6.jpg';
import SpaGradient from '../../assets/Industry_Spa_Hero_Gradient-75148b39d262e597c5965f447a8c737e.svg';
import SpaPhoto from '../../assets/Industry_Spa_Software_Fresha.b66df7eb.jpg';
import BarberGradient from '../../assets/Industry_Barber_Hero_Gradient-80ae653e174398dce70477d0c308dee8.svg';
import BarberPhoto from '../../assets/Industry_Barber_Software_Fresha.05bb918e.jpg';
import MassageGradient from '../../assets/Industry_Massage_Hero_Gradient.f5c7845c.jpg';
import MassagePhoto from '../../assets/Industry_Massage_Software_Fresha.be6af04f.jpg';
import MedSpaGradient from '../../assets/Industry_MedSpa_Hero_Gradient.93b61d74.jpg';
import MedSpaPhoto from '../../assets/Industry_MedSpa_Software_Fresha.0afc4a22.jpg';
import FitnessGradient from '../../assets/Industry_Fitness_Hero_Gradient.38f38d8e.jpg';
import FitnessPhoto from '../../assets/Industry_Fitness_Software_Fresha.beeb275f.jpg';
import TanningGradient from '../../assets/Industry_Tanning_Hero_Gradient.1eb89c85.jpg';
import TanningPhoto from '../../assets/Industry_Tanning_One-Solution_Fresha.cab9793e.jpg';
import TattooGradient from '../../assets/Industry_Tattoo_Hero_Gradient.7cfd09b8.jpg';
import TattooPhoto from '../../assets/Industry_Tattoo-Piercing_Software_Fresha.d4736b77.jpg';
import PetPhoto from '../../assets/Industry_PET_Software_Fresha.6ff140cf.jpg';
import NailsPhoto   from '../../assets/Industry_Nails_Software_Fresha.46347c46.jpg';
import DentalPhoto  from '../../assets/Industry_dental.jpg';
import ClinicsPhoto from '../../assets/clinic-aest.jpeg';
import OnlinePhoto  from '../../assets/Industry_Salon_Fresha_software_you_can_trust.239a423b.jpg';
import BeautyPhoto  from '../../assets/beauty_center.jpeg';

const CATEGORY_META = {
  hair:    { Icon: FaCut,            color: '#d946a8' },
  nails:   { Icon: FaRegGem,         color: '#ec4899' },
  spa:     { Icon: FaSpa,            color: '#10b981' },
  dental:  { Icon: FaTooth,          color: '#0ea5e9' },
  clinics: { Icon: FaHospital,       color: '#8b5cf6' },
  online:  { Icon: FaVideo,          color: '#2d8cff' },
  other:   { Icon: FaQuestionCircle, color: '#f59e0b' },
  barber:  { Icon: FaUserTie,        color: '#7c3aed' },
  massage: { Icon: FaHands,          color: '#0891b2' },
  medspa:  { Icon: FaLeaf,           color: '#059669' },
  fitness: { Icon: FaDumbbell,       color: '#ef4444' },
  tanning: { Icon: FaSun,            color: '#d97706' },
  tattoo:  { Icon: FaPenNib,         color: '#374151' },
  pet:     { Icon: FaPaw,            color: '#16a34a' },

  // Published by the 2026-09 expansion. No hero photo: the existing photo set
  // is competitor-sourced and is not being extended, so these lean on their
  // gradient plus the imagery in their detail rows.
  laser:     { Icon: FaBolt,           color: '#0891b2' },
  aesthetic: { Icon: FaSyringe,        color: '#8b5cf6' },
  academies: { Icon: FaGraduationCap,  color: '#7c3aed' },
  rentals:   { Icon: FaUmbrellaBeach,  color: '#0ea5e9' },
  physio:    { Icon: FaWalking,        color: '#059669' },
  nutrition: { Icon: FaAppleAlt,       color: '#16a34a' },
};

const CATEGORY_IMAGES = {
  hair:    { gradient: SalonGradient,   photo: SalonPhoto   },
  nails:   { gradient: null,            photo: NailsPhoto   },
  spa:     { gradient: SpaGradient,     photo: SpaPhoto     },
  barber:  { gradient: BarberGradient,  photo: BarberPhoto  },
  massage: { gradient: MassageGradient, photo: MassagePhoto },
  medspa:  { gradient: MedSpaGradient,  photo: MedSpaPhoto  },
  fitness: { gradient: FitnessGradient, photo: FitnessPhoto },
  tanning: { gradient: TanningGradient, photo: TanningPhoto },
  tattoo:  { gradient: TattooGradient,  photo: TattooPhoto  },
  pet:     { gradient: SpaGradient,     photo: PetPhoto     },
  dental:  { gradient: null,            photo: DentalPhoto  },
  clinics: { gradient: null,            photo: ClinicsPhoto },
  online:  { gradient: null,            photo: OnlinePhoto  },
  beauty:  { gradient: null,            photo: BeautyPhoto  },
  laser:     { gradient: MedSpaGradient, photo: null },
  aesthetic: { gradient: MedSpaGradient, photo: null },
  // Every new vertical gets an abstract gradient. Three of them had neither
  // gradient nor photo, which left the hero as a headline over 250px of empty
  // white before the next section. These are the existing abstract gradient
  // SVGs, not the photography, so nothing competitor-sourced is extended.
  academies: { gradient: SalonGradient,   photo: null },
  rentals:   { gradient: SpaGradient,     photo: null },
  physio:    { gradient: FitnessGradient, photo: null },
  nutrition: { gradient: SpaGradient,     photo: null },
  // /for/other had no entry at all, so it fell through to `null` and rendered
  // a headline over an empty hero. Pre-dates the 2026-09 expansion.
  other:     { gradient: SalonGradient,   photo: null },
};

function darkenColor(hex, amount = 0.55) {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.round(((num >> 16) & 0xff) * (1 - amount));
  const g = Math.round(((num >> 8) & 0xff) * (1 - amount));
  const b = Math.round((num & 0xff) * (1 - amount));
  return `rgb(${r},${g},${b})`;
}

const BusinessCategoryPage = ({ categoryKey }) => {
  const { t } = useTranslation();
  const { color } = CATEGORY_META[categoryKey] || { color: '#d946a8' };
  const isOther = categoryKey === 'other';
  const categoryImages = CATEGORY_IMAGES[categoryKey] || null;
  const darkColor = darkenColor(color);

  const seoMeta = SEO_CATEGORY_META[categoryKey] || {};

  // Detail rows, for the verticals that declare them. Absent for the rest,
  // which keep rendering exactly as they did.
  const rich = RICH_VERTICALS[categoryKey];

  const [faqOpen, setFaqOpen] = useState(null);

  /**
   * FAQs, and the FAQPage schema built from the very same strings.
   *
   * Google requires FAQ content to be VISIBLE on the page; structured data
   * describing questions a reader cannot find is grounds for a manual action.
   * Every vertical page on this site used to emit a hand-written faqSchema
   * from pageMeta.js while rendering no FAQ at all, so the markup described
   * three questions that appeared nowhere. Deriving both from one translated
   * source makes that impossible: no visible FAQ, no schema.
   */
  const faqNums = [1, 2, 3].filter((n) => {
    const q = t(`businesses.${categoryKey}.faq${n}Q`, '');
    const a = t(`businesses.${categoryKey}.faq${n}A`, '');
    return q && a && !q.startsWith('businesses.');
  });

  const faqJsonLd = faqNums.length ? [{
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqNums.map((n) => ({
      '@type': 'Question',
      name: t(`businesses.${categoryKey}.faq${n}Q`),
      acceptedAnswer: { '@type': 'Answer', text: t(`businesses.${categoryKey}.faq${n}A`) },
    })),
  }] : [];

  // GTM engagement signal — which vertical the visitor identifies with.
  // Builds a Google Ads audience like "viewed dental category page".
  useEffect(() => { trackViewBusinessCategory({ category: categoryKey }); }, [categoryKey]);

  return (
    <div className={styles.page}>
      <SEO
        title={seoMeta.title || ''}
        description={seoMeta.description || ''}
        canonical={seoMeta.canonical || `/for/${categoryKey}`}
        jsonLd={[...(seoMeta.jsonLd || []), ...faqJsonLd]}
      />
      <Navbar />

      {/* Hero */}
      <section className={styles.hero}>
        <div className="container">
          <div className={styles.heroInner}>
            <div className={styles.heroText}>
              <h1 data-aos="fade-up">
                {t(`businesses.${categoryKey}.heroTitlePre`)}{' '}
                <span style={{ color }}>{t(`businesses.${categoryKey}.heroTitleBrand`)}</span>{' '}
                {t(`businesses.${categoryKey}.heroTitlePost`)}
              </h1>
              <p data-aos="fade-up" data-aos-delay="100">
                {t(`businesses.${categoryKey}.heroSubtitle`)}
              </p>
              <a
                href={getOnboardingUrl("cta")}
                className={styles.heroCta}
                style={{ background: color }}
                data-aos="fade-up"
                data-aos-delay="200"
              >
                {isOther ? t('businesses.common.talkToUs') : t('businesses.common.cta')}
              </a>
            </div>
            {categoryImages && (
              <div className={styles.heroImageWrap} data-aos="fade-left" data-aos-delay="150">
                {categoryImages.gradient && (
                  <img src={categoryImages.gradient} className={styles.heroGradient} alt="" aria-hidden="true" />
                )}
                {categoryImages.photo && (
                  <img
                    src={categoryImages.photo}
                    className={styles.heroPhoto}
                    alt={t(`businesses.cards.${categoryKey}.title`, { defaultValue: '' })}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Why Stylon for this biz */}
      <section className={styles.whySection}>
        <div className="container">
          <h2 data-aos="fade-up">{t('businesses.common.whyTitle')} {t(`businesses.${categoryKey}.badge`)}</h2>
          <div className={styles.whyGrid}>
            {[1, 2, 3].map((n) => (
              <div key={n} className={styles.whyCard} data-aos="fade-up" data-aos-delay={n * 80}>
                <div className={styles.whyNum} style={{ backgroundColor: color + '18', color }}>{n}</div>
                <p>{t(`businesses.${categoryKey}.w${n}`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it helps */}
      <section className={styles.howSection}>
        <div className="container">
          <h2 data-aos="fade-up">{t('businesses.common.howTitle')}</h2>
          <div className={styles.howList}>
            {[1, 2, 3].map((n) => (
              <div key={n} className={styles.howItem} data-aos="fade-up" data-aos-delay={n * 70}>
                <div className={styles.howIcon} style={{ color }}>
                  <FaCheckCircle />
                </div>
                <div>
                  <p>{t(`businesses.${categoryKey}.h${n}`)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className={styles.benefits}>
        <div className="container">
          <h2 data-aos="fade-up">{t('businesses.common.benefitsTitle')}</h2>
          <div className={styles.benefitsGrid}>
            {[1, 2, 3, 4, 5, 6].map((n) => (
              <div key={n} className={styles.benefitItem} data-aos="fade-up" data-aos-delay={n * 50}>
                <FaCheckCircle className={styles.checkIcon} style={{ color }} />
                <span>{t(`businesses.${categoryKey}.b${n}`)}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {rich && (
        <DeepDive
          scope="businesses"
          featureKey={categoryKey}
          count={rich.deepDive}
          color={color}
        />
      )}

      {faqNums.length > 0 && (
        <section className={styles.faqSection}>
          <div className="container">
            <h2 data-aos="fade-up">{t('features.common.faqTitle')}</h2>
            <div className={styles.faqList}>
              {faqNums.map((n) => (
                <div
                  key={n}
                  className={`${styles.faqItem} ${faqOpen === n ? styles.faqItemOpen : ''}`}
                  onClick={() => setFaqOpen(faqOpen === n ? null : n)}
                >
                  <div className={styles.faqQuestion}>
                    <span>{t(`businesses.${categoryKey}.faq${n}Q`)}</span>
                    {faqOpen === n
                      ? <FaChevronUp className={styles.faqChevron} style={{ color }} />
                      : <FaChevronDown className={styles.faqChevron} style={{ color }} />}
                  </div>
                  {/*
                    Rendered always, hidden by CSS when collapsed rather than
                    unmounted: an accordion whose answers are absent from the
                    DOM is the same invisible-content problem in a nicer shape.
                  */}
                  <div className={faqOpen === n ? styles.faqAnswer : styles.faqAnswerHidden}>
                    <p>{t(`businesses.${categoryKey}.faq${n}A`)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* WhatsApp Reminders */}
      <section className={styles.whatsappSection} data-aos="fade-up">
        <div className="container">
          <div className={styles.whatsappInner}>
            <div className={styles.whatsappText}>
              <h2>{t('businesses.common.whatsappTitle')}</h2>
              <p>{t('businesses.common.whatsappSubtitle')}</p>
              <ul className={styles.whatsappList}>
                {[1, 2, 3].map((n) => (
                  <li key={n}>
                    <FaCheckCircle className={styles.whatsappCheck} />
                    <span>{t(`businesses.common.whatsapp${n}`)}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className={styles.whatsappVisual}>
              <FaWhatsapp className={styles.whatsappIcon} />
            </div>
          </div>
        </div>
      </section>

      <RelatedLinks scope="businesses" pageKey={categoryKey} color={color} />

      {/* CTA */}
      <section className={styles.ctaSection}>
        <div className="container">
          <h2>{t('businesses.common.ctaTitle')}</h2>
          <p>{t('businesses.common.ctaSubtitle')}</p>
          <a
            href={getOnboardingUrl("cta")}
            className={styles.ctaButton}
          >
            {isOther ? t('businesses.common.talkToUs') : t('businesses.common.cta')}
          </a>
        </div>
      </section>

      <Footer accentColor={darkColor} />
    </div>
  );
};

export default BusinessCategoryPage;
